<template>
  <Authorizations :id="$props.id" store="organizationStore"></Authorizations>
</template>

<script>
import Authorizations from "../common/tabs/Authorizations.vue";

export default {
  name: "UsersOrganization",
  props: ["id"],
  components: { Authorizations }
};
</script>
